<div *ngIf="showByCarrier; else byLoad">
    <app-collapsible [opened]="true"
                     *ngFor="let byRegion of groupedBluechatLoads | keyvalue"
                     [arrowElementRef]="regionArrow">
        <div (click)="regionArrow.triggerToggle($event)"
             collapsibleHeader
             class="region-item">
            <span>{{regions[byRegion.key].name}}</span>
            <app-collapsible-arrow #regionArrow></app-collapsible-arrow>
        </div>
        <app-collapsible [opened]="true"
                         collapsibleBody
                         *ngFor="let byCarrier of byRegion.value | keyvalue"
                         [arrowElementRef]="carrierArrow">
            <div (click)="carrierArrow.triggerToggle($event)" collapsibleHeader class="carrier-item">
                <div class="checkbox">
                    <label *ngIf="carriers[byCarrier.key].bluechatEnabled">
                        <input type="checkbox"
                               (click)="selectCarrier(byCarrier.key)"
                               [disabled]="!userCanCreateNote"
                               [checked]="_selectedCarriers[byCarrier.key] ? 'checked' : null">
                        <i class="fa checkbox-icon hasBorder"></i>
                    </label>
                </div>
                <span>{{carriers[byCarrier.key].name}}</span>
                <app-collapsible-arrow #carrierArrow></app-collapsible-arrow>
            </div>
            <ng-container collapsibleBody *ngFor="let bluechatload of byCarrier.value">
                <app-bluechat-load
                    [load]="bluechatload"
                    [selectedDeliveries]="_selectedLoads[bluechatload.loadNumber]"
                    [userCanCreateNote]="userCanCreateNote"
                    [carrierHasBluechat]="carriers[byCarrier.key].bluechatEnabled"
                    (selectDeliveries)="selectDeliveries(bluechatload.loadNumber, $event)"
                    (createNoteClicked)="createNote.emit($event)"
                    (infoClicked)="openDetail.emit(bluechatload)"
                ></app-bluechat-load>
            </ng-container>
        </app-collapsible>
    </app-collapsible>
</div>

<ng-template #byLoad>
    <ng-container *ngFor="let bluechatload of bluechatLoads">
        <app-bluechat-load [load]="bluechatload"
                           [selectedDeliveries]="_selectedLoads[bluechatload.loadNumber]"
                           [userCanCreateNote]="userCanCreateNote"
                           [carrierHasBluechat]="carriers[bluechatload.blueyonderCarrierCode].bluechatEnabled"
                           (selectDeliveries)="selectDeliveries(bluechatload.loadNumber, $event)"
                           (createNoteClicked)="createNote.emit($event)"
                           (infoClicked)="openDetail.emit(bluechatload)">
        </app-bluechat-load>
    </ng-container>
</ng-template>
